import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const FormattedAmount = props => {

    const {onChange, suffix, decimalScale = 2, ...other} = props;

    return (
        <NumberFormat
            {...other}

            thousandSeparator={'.'}
            decimalSeparator={','}
            allowNegative={false}
            decimalScale={decimalScale}
            fixedDecimalScale={false}
            suffix={suffix}
        />
    );
};

FormattedAmount.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired,
    suffix: PropTypes.any.isRequired,
    decimalScale: PropTypes.any.isRequired
};

export default (FormattedAmount);
